import * as e from "react";
const c = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 3c.38-.003.73.234.9.61l2 4.437c.06.155.1.333.1.5.002 1.603-.775 3.062-2 3.846V18a3 3 0 01-3 3H7a3 3 0 01-3-3v-5.61c-1.196-.768-2-2.202-2-3.844a1.213 1.213 0 01.1-.499l2-4.437c.171-.376.52-.613.9-.61h14zM6 12.983V18a1 1 0 001 1h10a1 1 0 001-1v-5.012c-.523 0-1.04-.114-1.521-.334A4.029 4.029 0 0115 11.486a4.029 4.029 0 01-1.472 1.17 3.65 3.65 0 01-1.528.337c-.53 0-1.05-.117-1.53-.338A4.03 4.03 0 019 11.485a4.025 4.025 0 01-1.472 1.165c-.48.218-.998.334-1.528.333zM18.333 5l1.664 3.691c-.043.912-.5 1.65-1.075 2.018-.066.042-.129.088-.19.138a1.926 1.926 0 01-.163.046c-.22.053-.461.083-.616.094-.474-.014-.987-.242-1.387-.746a2 2 0 00-3.135.004c-.406.514-.937.748-1.43.748-.495 0-1.026-.234-1.432-.748a2 2 0 00-3.134-.005c-.406.511-.937.744-1.43.743-.088 0-.176.005-.263.017a1.067 1.067 0 01-.226-.058 1.8 1.8 0 01-.334-.166 2.057 2.057 0 00-.102-.07c-.564-.362-1.032-1.087-1.076-2.015L5.667 5h12.666z",
      fill: "#2d6ded"
    }
  )
), l = c;
export {
  l as default
};
